module.exports = __webpack_public_path__ + "static/media/carta_23.acb9bd6a.jpg";